import React from 'react';
import SelectPopup from './SelectPopup';
import RFIDInstance from '../../../native-interact/RFID';
import { getCmdPage } from '../../../service/command';

const modules = [
  'cpu1',
  'cpu2',
  'rtc',
  'radar',
  'geo'
];

export default function Reboot() {
  return (
    <SelectPopup
      title="重置"
      modules={modules}
      defaultSelectValue={modules[0]}
      onConfirm={(module) => {
        const cmd = `reset ${module}`;
        return RFIDInstance.write(
          {
            step: `reset_${module}`,
            desc: `重置${module}`
          },
          getCmdPage(cmd),
          cmd
        );
      }}
    />
  );
}
